import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import PlatformIcon from '../common/PlatformIcon';
import { PINKE_BRAND_COLORS } from '@cubemeet/core';

export interface SettingsHeaderProps {
  title: string;
  showBackButton?: boolean;
  onBack?: () => void;
  showCloseButton?: boolean;
  onClose?: () => void;
}

const SettingsHeader: React.FC<SettingsHeaderProps> = ({ 
  title, 
  showBackButton = true,
  onBack,
  showCloseButton = false,
  onClose
}) => {
  // Use safe area insets if available, otherwise fallback to 0
  let insets = { top: 0, bottom: 0, left: 0, right: 0 };
  try {
    insets = useSafeAreaInsets() || insets;
  } catch (e) {
    // ignore error if provider is missing
  }
  
  const headerHeight = (insets?.top || 0) + 64;
  const paddingTop = (insets?.top || 0) + 8;
  const backgroundColor = (PINKE_BRAND_COLORS && PINKE_BRAND_COLORS[1]) ? PINKE_BRAND_COLORS[1] : '#4A86F7';

  return (
    <View style={[
      styles.headerContainer,
      { height: headerHeight, paddingTop: paddingTop, backgroundColor }
    ]}>
      <View style={styles.headerContent}>
        {showBackButton && (
          <TouchableOpacity 
            style={styles.backButton} 
            onPress={onBack}
          >
            <PlatformIcon name="arrow-back" size={24} color="#FFFFFF" family="MaterialIcons" />
          </TouchableOpacity>
        )}
        {showCloseButton && (
          <TouchableOpacity 
            style={styles.backButton} 
            onPress={onClose}
          >
            <PlatformIcon name="close" size={24} color="#FFFFFF" family="MaterialIcons" />
          </TouchableOpacity>
        )}
        <Text style={styles.headerTitle}>{title}</Text>
        {(showBackButton || showCloseButton) && <View style={styles.headerRight} />}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    width: '100%',
    maxWidth: 600,
    alignSelf: 'center',
    // backgroundColor set via inline style
    // borderBottomWidth: 1, // Removed to merge with content
    // borderBottomColor: 'rgba(255,255,255,0.2)',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    overflow: 'hidden',
    ...Platform.select({
      default: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3,
      },
      web: {
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }
    }),
  },
  headerContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingBottom: 12,
  },
  backButton: {
    padding: 8,
    marginLeft: -8,
    borderRadius: 20,
  },
  headerTitle: {
    flex: 1,
    fontSize: 18,
    fontWeight: '600',
    color: '#FFFFFF',
    textAlign: 'center',
    marginHorizontal: 16,
  },
  headerRight: {
    width: 40, // 保持标题居中
  },
});

export default SettingsHeader;
